/** @format */

import styled from '@emotion/styled';

const VSpacer = styled.div`
  padding-bottom: 24px;
`;

export default VSpacer;
